/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  margin-bottom: 100px;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 24px;
  padding-right: 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HeaderText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 38px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;
const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const PIndent90 = styled.p`
  margin-left: 90px;
`;
const SpanIndent90 = styled.span`
  margin-left: 90px;
`;

class SectionHistory extends Component {
  render() {
    return (
      <div className="SectionHistory">

        <Section className="section section-header hero-wrap">
          <ContainerFluid className="container-fluid">
            <HeaderText className="header-text">
              <span className="header-text-700">회사 연혁</span>
            </HeaderText>
            <div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2011년</SpanAbsoluteBold>
                <PIndent90>
                  <span>봄시스템즈 설립.</span>
                  <br/>
                  <span>코레이트 보안솔루션 파트너 협약 체결.</span>
                </PIndent90>
              </div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2014년</SpanAbsoluteBold>
                <PIndent90>
                  <span>LG CNS 협력사 등록.</span>
                </PIndent90>
              </div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2015년</SpanAbsoluteBold>
                <PIndent90>
                  <span>LG CNS 보안솔루션 공급 계약 체결.</span>
                  <br/>
                  <span>LG 서브원 협력사 등록.</span>
                </PIndent90>
              </div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2016년</SpanAbsoluteBold>
                <PIndent90>
                  <span>LG 마곡 R&D센터 보안솔루션 공급 계약 체결.</span>
                </PIndent90>
              </div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2017년</SpanAbsoluteBold>
                <PIndent90>
                  <span>주식회사 안 Healthcare 파트너 협약 체결.</span>
                </PIndent90>
              </div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2018년</SpanAbsoluteBold>
                <PIndent90>
                  <span>AR(Augmented Reality) 솔루션 개발 및 사업 진출.</span>
                  <br/>
                  <span>Epson Smartglass 삼성SDS 공급.</span>
                </PIndent90>
              </div>
              <div style={{position:'relative'}}>
                <SpanAbsoluteBold>2019년</SpanAbsoluteBold>
                <PIndent90>
                  <span>Epson CR(Corporate Reseller) 등록.</span>
                  <br/>
                  <span>SM Entertainment 프린팅 솔루션 공급 계약 체결.</span>
                  <br/>
                  <span>파이어아이 파트너 등록.</span>
                </PIndent90>
              </div>
            </div>
          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default SectionHistory;
